import createIcon from '../../createIcon';

/**
 * @component @name Mediation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTJMMTggMTZMMTYuNTkgMTQuNTlMMTguMTcgMTNIMTIuOTRDMTIuNiAxNi4xIDEwLjY4IDE4LjcyIDggMjAuMDVDNy45NiAyMS42OSA2LjY0IDIzIDUgMjNDMy4zNCAyMyAyIDIxLjY2IDIgMjBDMiAxOC4zNCAzLjM0IDE3IDUgMTdDNS45NSAxNyA2Ljc4IDE3LjQ1IDcuMzMgMTguMTRDOS4yMyAxNy4xMSAxMC41OSAxNS4yMyAxMC45MSAxM0g3LjgxQzcuNCAxNC4xNiA2LjMgMTUgNSAxNUMzLjM0IDE1IDIgMTMuNjYgMiAxMkMyIDEwLjM0IDMuMzQgOSA1IDlDNi4zIDkgNy40IDkuODQgNy44MiAxMUgxMC45MkMxMC42IDguNzcgOS4yMyA2LjkgNy4zMyA1Ljg2QzYuNzggNi41NSA1Ljk1IDcgNSA3QzMuMzQgNyAyIDUuNjYgMiA0QzIgMi4zNCAzLjM0IDEgNSAxQzYuNjQgMSA3Ljk2IDIuMzEgNy45OSAzLjk1QzEwLjY3IDUuMjggMTIuNTkgNy45IDEyLjkzIDExSDE4LjE2TDE2LjU4IDkuNDFMMTggOEwyMiAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mediation = createIcon('Mediation', [
  [
    'path',
    {
      d: 'M22 12L18 16L16.59 14.59L18.17 13H12.94C12.6 16.1 10.68 18.72 8 20.05C7.96 21.69 6.64 23 5 23C3.34 23 2 21.66 2 20C2 18.34 3.34 17 5 17C5.95 17 6.78 17.45 7.33 18.14C9.23 17.11 10.59 15.23 10.91 13H7.81C7.4 14.16 6.3 15 5 15C3.34 15 2 13.66 2 12C2 10.34 3.34 9 5 9C6.3 9 7.4 9.84 7.82 11H10.92C10.6 8.77 9.23 6.9 7.33 5.86C6.78 6.55 5.95 7 5 7C3.34 7 2 5.66 2 4C2 2.34 3.34 1 5 1C6.64 1 7.96 2.31 7.99 3.95C10.67 5.28 12.59 7.9 12.93 11H18.16L16.58 9.41L18 8L22 12Z',
      key: '1uvxsf',
    },
  ],
]);

export default Mediation;
